import React, { useRef, Fragment } from 'react';
import './Factbox.scss';
import FactboxCarousel from './FactboxCarousel';

function Factbox({ touch }) {
  const container = useRef();
  const data = [
    { year: 2021, rate: 3.12, payment: '1,242', spent: 17.4, sales: 6.12 },
    { year: 2022, rate: 6.98, payment: '2,044', spent: 27.4, sales: 5.13 }
  ];

  return (
    <figure className="factbox" ref={container}>
      <div className="factbox-container">
        <h3 className="factbox__head">the difference a year makes</h3>
        <div className="factbox__contents">
          {data.map(({ year, rate, payment, spent, sales }, i) => {
            return (
              <Fragment key={i}>
                <dl
                  className={
                    i === 0
                      ? 'factbox__year factbox__year-desktop factbox__year--left'
                      : 'factbox__year factbox__year-desktop'
                  }
                >
                  <h4 className="factbox__year__head">October {year}</h4>
                  <dt className="factbox__year__subhead">Average 30-Year Fixed Morgage Rate</dt>
                  <dd className="factbox__year__copy">{rate}%</dd>
                  <dt className="factbox__year__subhead">Average Monthly Mortgage Payment</dt>
                  <dd className="factbox__year__copy">${payment}</dd>
                  <dt className="factbox__year__subhead">Existing Home Sales</dt>
                  <dd className="factbox__year__copy">{sales} million</dd>
                </dl>
              </Fragment>
            );
          })}
          <FactboxCarousel data={data} touch={touch} />
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Factbox;
